import { AxiosRequestConfig } from 'axios';
import { z } from 'zod';
import { getMasterDataHub } from '@rossum/mdh-api-client';
import { absoluteApiUrl, mdhUrl } from '../../constants/config';
import { getAuthToken } from '../../lib/token';
import store from '../../redux/configureStore';
import { safeOrganizationSelector } from '../../redux/modules/organization/selectors';

const mdhTokenSchema = z.object({
  // Camelified by redux
  mdhMasterToken: z.string(),
});

const isApiDevelop =
  absoluteApiUrl.startsWith('https://elis.develop.r8.lol') ||
  absoluteApiUrl.startsWith('https://api.elis.develop.r8.lol');

const isApiReview =
  /^https:\/\/review-ac-elis-backend-\d+\.review\.r8\.lol/.test(absoluteApiUrl);

const isNonProduction = isApiDevelop || isApiReview;

export const getMdhTokenOverride = (): string | null => {
  if (!isNonProduction) return null;

  const organization = safeOrganizationSelector(store.getState());
  const parsed = mdhTokenSchema.safeParse(organization?.metadata);
  return parsed.success ? parsed.data.mdhMasterToken : null;
};

export const datasetApi = getMasterDataHub();

const getMdhCredentials = (): {
  baseURL: string;
  token: string | null;
  xRossumDev: string;
} => {
  const tokenOverride = getMdhTokenOverride();

  if (tokenOverride) {
    return { baseURL: mdhUrl, token: tokenOverride, xRossumDev: '' };
  }

  if (isApiDevelop) {
    return { baseURL: mdhUrl, token: getAuthToken(), xRossumDev: 'true' };
  }

  return { baseURL: mdhUrl, token: getAuthToken(), xRossumDev: '' };
};

export const getDatasetRequestConfig: () => AxiosRequestConfig = () => {
  const { baseURL, token, xRossumDev } = getMdhCredentials();

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Request-Source': 'web_app',
      ...(xRossumDev ? { 'X-ROSSUM-DEV': xRossumDev } : {}),
    },
    // Since the prefix is already in openapi spec, we need to strip it from the base URL
    baseURL: baseURL.replace('/svc/master-data-hub', ''),
  };
};
